import { useAuth } from '../auth/AuthContext.tsx'
import { Shell } from '../components/Shell.tsx'
import { UserTab } from '../components/UserTab.tsx'
import { Require } from './guards.tsx'

function MyTabInner() {
  const { session } = useAuth()
  if (!session) return null
  return (
    <Shell title="My Tab">
      <UserTab userId={session.auth.sub} />
    </Shell>
  )
}

export function MyTabPage() {
  return (
    <Require roles={['member', 'admin']}>
      <MyTabInner />
    </Require>
  )
}
